import {
  CUSTOMER_CHANGE_VALUE,
  CUSTOMER_CHANGE_VALUES,
  CUSTOMER_SET_CUSTOMERS,
  CUSTOMER_CHANGE_TABLE_OPTION,
  CUSTOMER_CHANGE_TABLE_SORT,
  CUSTOMER_CHANGE_PROFILE_TAB,
} from '@shared/store/constants/mutationTypes';

import apiClient from '@shared/lib/general/apiClient';

let controller = new AbortController();

const actions = {
  changeCustomerProfileTab({ commit }, payload) {
    const { activeTab, filter } = payload;

    commit({
      type: CUSTOMER_CHANGE_PROFILE_TAB,
      activeTab,
      filter,
    });
  },
  changeCustomerValue({ commit }, payload) {
    const { field, value } = payload;

    commit({
      type: CUSTOMER_CHANGE_VALUE,
      field,
      value,
    });
  },
  changeCustomerValues({ commit }, changes) {
    commit({
      type: CUSTOMER_CHANGE_VALUES,
      changes,
    });
  },
  changeTableOption({ commit }, payload) {
    const { field, value } = payload;

    commit({
      type: CUSTOMER_CHANGE_TABLE_OPTION,
      field,
      value,
    });
  },
  changeCustomerTableSortOption({ commit }, payload) {
    const { sortBy, sortDesc } = payload;

    commit({
      type: CUSTOMER_CHANGE_TABLE_SORT,
      sortBy,
      sortDesc,
    });
  },
  async getCustomersCount({ commit, rootState }) {
    try {
      const {
        admin: {
          adminFilter: { corpId },
        },
      } = rootState;
      const { data } = await apiClient({
        method: 'GET',
        url: `/customers/list/count?corpId=${corpId}`,
      });
      commit({
        type: CUSTOMER_CHANGE_VALUE,
        field: 'customersCount',
        value: data,
      });
    } catch (err) {
      console.error(err);
    }
  },
  async getAllCustomers({ commit, rootState, state }) {
    commit({
      type: CUSTOMER_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });
    try {
      const {
        admin: {
          adminFilter: { corpId },
        },
      } = rootState;
      const {
        customerTableOptions,
        selectedPlanIds,
        hasVirtualVisit,
        customerTableSearch,
        activeProfileTab,
        selectedMembershipTypes,
      } = state;
      controller.abort();
      controller = new AbortController();
      let query = '';
      if (selectedPlanIds.length > 0) {
        selectedPlanIds.forEach((el) => {
          query += `&providerPlanIds=${el}`;
        });
      }
      if (selectedMembershipTypes.length > 0) {
        selectedMembershipTypes.forEach((type) => {
          query += `&membershipTypes=${type}`;
        });
      }
      let status = 'Active';
      if (activeProfileTab === 'all') {
        status = '';
      } else if (activeProfileTab === 'invited') {
        status = 'Invited';
      }
      let membershipStatus = null;
      if (activeProfileTab === 'canceled') {
        membershipStatus = 'Canceled';
        status = null;
      } else if (activeProfileTab === 'pending cancellation') {
        membershipStatus = 'Pending Cancellation';
        status = null;
      }
      const { data: customers } = await apiClient({
        method: 'GET',
        signal: controller.signal,
        url: `/customers/list?corpId=${corpId}${query}`,
        params: {
          page: customerTableOptions.page,
          limit: customerTableOptions.itemsPerPage,
          sort: customerTableOptions.sortBy[0],
          sortType: customerTableOptions.sortDesc[0] ? 'descending' : 'ascending',
          search: customerTableSearch,
          status,
          profileState: activeProfileTab,
          hasVirtualVisit,
          membershipStatus,
        },
      });

      const { data: partnerSettings } = await apiClient({
        method: 'GET',
        url: `/partner/settings/${Math.abs(corpId)}`,
      });

      const allCustomers = customers.data;

      const profileCompleted = [];
      const profileIncompleted = [];
      const baseProfile = [];

      commit({
        type: CUSTOMER_SET_CUSTOMERS,
        allCustomers,
        profileIncompleted,
        profileCompleted,
        baseProfile,
      });
      commit({
        type: CUSTOMER_CHANGE_VALUES,
        changes: [
          {
            field: 'selectedPartnerSettings',
            value: partnerSettings,
          },
          {
            field: 'customerTableOptions',
            value: {
              ...customerTableOptions,
              page: customers.page,
              itemsPerPage: customers.pageSize,
              totalItems: customers.totalCount,
            },
          },
        ],
      });
    } catch (err) {
      commit({
        type: CUSTOMER_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      throw err;
    }
  },

  async exportCustomerData({ commit, rootState, state }) {
    const {
      admin: {
        adminFilter: {
          corpId,
        },
      },
    } = rootState;
    const {
      activeProfileTab,
    } = state;
    controller.abort();
    let status = 'Active';
    if (activeProfileTab === 'all') {
      status = '';
    } else if (activeProfileTab === 'invited') {
      status = 'Invited';
    }
    let membershipStatus = null;
    if (activeProfileTab === 'canceled') {
      membershipStatus = 'Canceled';
      status = null;
    } else if (activeProfileTab === 'pending cancellation') {
      membershipStatus = 'Pending Cancellation';
      status = null;
    }
    commit({
      type: CUSTOMER_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });
    try {
      const { data } = await apiClient({
        method: 'GET',
        url: `/customers/corporation/${corpId}/exportcsv`,
        params: {
          profileState: activeProfileTab,
          profileStatus: status,
          membershipStatus,
        }
      });
      commit({
        type: CUSTOMER_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      return data;
    } catch (err) {
      commit({
        type: CUSTOMER_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      throw err;
    }
  },

  async getCustomerHubs({ commit, state }, payload) {
    try {
      const customerId = payload;
      const { data: hubList } = await apiClient({
        method: 'GET',
        url: `/devices/hub/customer/${customerId}`,
      });
      const { allCustomers } = state;
      const newCustomers = JSON.parse(JSON.stringify(allCustomers));
      newCustomers.find((x) => x.id === customerId).hubs = hubList;
      const profileCompleted = [];
      const profileIncompleted = [];
      const baseProfile = [];
      commit({
        type: CUSTOMER_SET_CUSTOMERS,
        allCustomers: newCustomers,
        profileIncompleted,
        profileCompleted,
        baseProfile,
      });
    } catch (err) {
      console.error(err);
    }
  },

  async parseMemberUpload({ dispatch, commit }, payload) {
    const text = payload;

    const textSplit = text.split('\n');
    const errorObj = {};
    const uploadErrorArr = [];
    let fIdx = -1;
    let lIdx = -1;
    let phoneIdx = -1;
    let emailIdx = -1;
    let address1Idx = -1;
    let address2Idx = -1;
    let cityIdx = -1;
    let stateIdx = -1;
    let postalCodeIdx = -1;
    let countryIdx = -1;
    const headers = textSplit.splice(0, 1)[0].split(',');
    headers.forEach((h, idx) => {
      const lowerCase = h.toLowerCase();
      if (lowerCase.includes('first')) {
        fIdx = idx;
      } else if (lowerCase.includes('last')) {
        lIdx = idx;
      } else if (lowerCase.includes('phone') || lowerCase.includes('number')) {
        phoneIdx = idx;
      } else if (lowerCase.includes('email')) {
        emailIdx = idx;
      } else if (lowerCase === 'address' || lowerCase.includes('address1') || lowerCase.includes('address 1')) {
        address1Idx = idx;
      } else if (lowerCase.includes('address2') || lowerCase.includes('address 2')) {
        address2Idx = idx;
      } else if (lowerCase.includes('city')) {
        cityIdx = idx;
      } else if (lowerCase.includes('state')) {
        stateIdx = idx;
      } else if (lowerCase.includes('postalcode') || lowerCase.includes('postal code') || lowerCase.includes('zipcode') || lowerCase.includes('zip code')) {
        postalCodeIdx = idx;
      } else if (lowerCase.includes('country')) {
        countryIdx = idx;
      }
    });

    if (fIdx === -1) {
      uploadErrorArr.push('First Name column is missing!');
    }
    if (lIdx === -1) {
      uploadErrorArr.push('Last Name column is missing!');
    }
    if (phoneIdx === -1) {
      uploadErrorArr.push('Phone column is missing!');
    }
    if (emailIdx === -1) {
      uploadErrorArr.push('Email column is missing!');
    }
    if (address1Idx === -1) {
      uploadErrorArr.push('Address 1 column is missing!');
    }
    if (cityIdx === -1) {
      uploadErrorArr.push('City column is missing!');
    }
    if (stateIdx === -1) {
      uploadErrorArr.push('State column is missing!');
    }
    if (postalCodeIdx === -1) {
      uploadErrorArr.push('Postal Code / Zip Code column is missing!');
    }
    if (countryIdx === -1) {
      uploadErrorArr.push('Country column is missing!');
    }


    if (uploadErrorArr.length === 0) {
      const allCustomers = [];
      textSplit.forEach((row) => {
        const info = row.split(',');
        if (info.length > 1) {
          const cleanedInfo = info.map((v) => {
            let value = v;
            if (v.indexOf('\r') !== -1) {
              value = v.substring(0, v.indexOf('\r'));
            }
            return value.trim();
          });
          const firstName = cleanedInfo[fIdx];
          const lastName = cleanedInfo[lIdx];
          const email = cleanedInfo[emailIdx];
          const phone = cleanedInfo[phoneIdx];
          const address1 = address1Idx > -1 ? cleanedInfo[address1Idx] : null;
          const address2 = address2Idx > -1 ? cleanedInfo[address2Idx] : null;
          const city = cityIdx > -1 ? cleanedInfo[cityIdx] : null;
          const state = stateIdx > -1 ? cleanedInfo[stateIdx] : null;
          const postalCode = postalCodeIdx > -1 ? cleanedInfo[postalCodeIdx] : null;
          const country = countryIdx > -1 ? cleanedInfo[countryIdx] : null;

          allCustomers.push({
            firstName,
            lastName,
            email,
            phone,
            address1,
            address2,
            city,
            state,
            postalCode,
            country,
          });
        }
      });
      if (uploadErrorArr.length > 0) {
        errorObj.uploadErrorArr = uploadErrorArr;
        commit({
          type: CUSTOMER_CHANGE_VALUES,
          changes: [
            {
              field: 'parsingErrorObj',
              value: errorObj,
            },
          ]
        });
      } else if (allCustomers.length > 0) {
        const validations = allCustomers.map(async (s, idx) => {
          try {
            const { data } = await apiClient({
              method: 'GET',
              url: `/customers/check/email/${s.email}`,
            });
            if (data.email === s.email) {
              errorObj[`email-${idx}`] = 'User already exists. Please use a different email address.';
            }
          } catch (err) {
            console.error(err);
          }
        });

        await Promise.all(validations);

        dispatch('changeCustomerValues', [
          {
            field: 'parsingErrorObj',
            value: errorObj,
          },
        ]);
        commit({
          type: CUSTOMER_CHANGE_VALUES,
          changes: [
            {
              field: 'actionModalView',
              value: 'create-cust',
            },
            {
              field: 'newCustomersUpload',
              value: allCustomers,
            },
            {
              field: 'parsingErrorObj',
              value: errorObj,
            },
          ]
        });
      }
    } else {
      errorObj.uploadErrorArr = uploadErrorArr;

      commit({
        type: CUSTOMER_CHANGE_VALUES,
        changes: [
          {
            field: 'parsingErrorObj',
            value: errorObj,
          },
        ]
      });
    }

  },

  async batchMembers({
    dispatch, rootState,
  }, payload) {
    const {
      members,
      providerPlanId
    } = payload;

    const {
      admin: {
        adminFilter: {
          corpId,
        },
      },
    } = rootState;

    const errorObj = {};

    let selectedCorpId = corpId;


    const memberMapped = members.map((member) => ({
      providerPlanId,
      firstName: member.firstName,
      lastName: member.lastName,
      email: member.email,
      phone: member.phone,
      serviceAddress: [{
        address1: member.address1,
        address2: member.address2,
        city: member.city,
        country: member.country,
        state: member.state,
        zip: parseInt(member.postalCode),
      }],
      billingAddress: {
        address1: member.address1,
        address2: member.address2,
        city: member.city,
        country: member.country,
        state: member.state,
        zip: parseInt(member.postalCode),
      },
      corporationId: selectedCorpId,
    }));

    const validations = memberMapped.map(async (s, idx) => {
      try {
        const { data } = await apiClient({
          method: 'GET',
          url: `/customers/check/email/${s.email}`,
        });
        if (data.email === s.email) {
          errorObj[`email-${idx}`] = 'User already exists. Please use a different email address.';
        }
      } catch (err) {
        console.error(err);
      }
    });

    await Promise.all(validations);

    dispatch('changeCustomerValues', [
      {
        field: 'parsingErrorObj',
        value: errorObj,
      },
    ]);

    if (Object.keys(errorObj).length === 0) {
      try {
        await apiClient({
          method: 'POST',
          url: '/customers/batch/invite',
          data: memberMapped,
        });

        if (memberMapped.length > 1) {
          dispatch('showSuccessToast', {
            header: 'Bulk upload complete.',
            message: `${memberMapped.length} members invited successfully.`,
          });
        } else {
          dispatch('showSuccessToast', {
            header: 'Bulk upload complete.',
            message: `${memberMapped.length} member invited successfully.`,
          });
        }

        return true;
      } catch (err) {
        console.error(err);
        dispatch('showAlertToast', {
          header: 'There was an unexpected error.',
          message: 'Please try again or contact support.',
        });
        throw err;
      }
    }
    return false;
  },
}
export default actions;
